<template>
<BModal
  v-model="isModalVisible"
  title="Preview"
  ok-title="Start"
  :lazy="true"
  @ok.prevent="run"
  @hidden="close"
>
  <div class="control-group">
    <div class="controls"><input type="text" v-model="redirectUrl" id="redirectUrl" disabled class="w-100" /></div>
  </div>

  <div class="control-group" :class="{ error: v$.form.url.$error }">
    <label class="control-label" for="url">Url</label>
    <div class="controls"><input type="text" v-model="form.url" id="url" class="w-100" /></div>
  </div>

  <div class="control-group" :class="{ error: v$.form.clientId.$error }">
    <label class="control-label" for="clientId">Client ID</label>
    <div class="controls"><input type="text" v-model="form.clientId" id="clientId" class="w-100" /></div>
  </div>
</BModal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { helpers, required } from '@vuelidate/validators'
import Form from '~/components/Form.vue';
import PreviewHelper from '~/helpers/PreviewHelper';
import SoftwareHelper from '~/helpers/SoftwareHelper';
import LoadingAnimation from '~/windowEvents/LoadingAnimation';
import Notify from '~/widgets/Notify';
import GroupTrackersConfigApiClient from '~/apiClients/GroupTrackersConfigApiClient';
import SoftwareTrackersConfigApiClient from '~/apiClients/SoftwareTrackersConfigApiClient';

export default defineComponent({
  name: 'PreviewModal',
  extends: Form,
  props: {
    isVisible: Boolean
  },
  data(): any {
    return {
      form: {
        clientId: '' as string,
        url: '' as string,
      },
      redirectUrl: '' as string,
      isModalVisible: false,
    };
  },
  beforeMount() {
    this.form.url = PreviewHelper.getUrl();
    this.form.clientId = PreviewHelper.getClientId();
    this.setRedirectUrl();
  },
  methods: {
    close() {
      this.$emit('close');
    },

    async publishConfig() {
      try {
        await LoadingAnimation.perform(async () => {
          const software = SoftwareHelper.getSelectedSoftwareObject();
          if (!SoftwareHelper.validateSoftware(software)) {
            return;
          }
          if (SoftwareHelper.isAutoV10(software)) {
            await (new GroupTrackersConfigApiClient()).publish(true);
          } else {
            await (new SoftwareTrackersConfigApiClient()).publish(true, software.id);
          }
        });
      } catch (error) {
        Notify.error('Error occurred. Please try again');
      }
    },

    async run() {
      await this.submit(async () => {
        PreviewHelper.setClientId(this.form.clientId);
        PreviewHelper.setUrl(this.form.url);
        await this.publishConfig();
        window.open(this.redirectUrl, '_blank');
        this.close();
      });
    },

    setRedirectUrl() {
      this.redirectUrl = PreviewHelper.buildRedirectUrl(this.form.url, this.form.clientId);
    },
  },
  watch: {
    'form.clientId': 'setRedirectUrl',
    'form.url': 'setRedirectUrl',
    'isVisible': function() {
      this.isModalVisible = this.isVisible;
      return this.isModalVisible;
    }
  },
  validations() {
    return {
      form: {
        clientId: {
          required: helpers.withMessage('Client ID cannot be empty', required),
        },
        url: {
          required: helpers.withMessage('Url cannot be empty', required),
        },
      },
    };
  },
});
</script>

